import { Dialog, Transition } from "@headlessui/react";
import UserService from "app/services/userService";
import React, { FC, Fragment, useEffect, useRef, useState } from "react";

import Notify from "./Notify";
import toast from "react-hot-toast";

export interface ModalBoostProps {
  show: boolean;
  productId: number;
  onCloseModalBoost: () => void;
  onBoostClick: ()=> void;
}

const ModalBoost: FC<ModalBoostProps> = ({
  show,
  productId,
  onCloseModalBoost,
  onBoostClick,
}) => {
 
    const [nbBoost, setNbBosst] = useState<Number>(0)
    useEffect(() => {
        UserService.getBoost().then(data => {
            setNbBosst(data)
        })
    }, [show]);

    const onBoost = () =>{
        
        UserService.boostProduct(productId).then(data => {
            if(data){
              toast.custom((t) => (<Notify 
                t={t}
                message='Votre produit a été boosté!'
                status =''
              />))
              onBoostClick()
              onCloseModalBoost()
            }
                
        })
        


    }

    return (
    <Transition appear show={show} as={Fragment}>
    <Dialog as="div" className="relative z-10" onClose={onCloseModalBoost}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-black bg-opacity-25" />
      </Transition.Child>

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
              <Dialog.Title
                as="h3"
                className="text-lg font-medium leading-6 text-gray-900"
              >
                Booster votre produit!
              </Dialog.Title>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  Vous avez {`${nbBoost}`} boosts, vous voulez utiliser un pour booster ce produit ?
                </p>
              </div>

              <div className="mt-4">
                <button
                  type="button"
                  className="mr-5 inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
                  onClick={onBoost}
                >
                 0ui vas-y
                </button>
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent bg-orange-100 px-4 py-2 text-sm font-medium text-orange-900 hover:bg-orange-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-500 focus-visible:ring-offset-2"
                  onClick={onCloseModalBoost}
                >
                  Annuler
                </button>
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </div>
    </Dialog>
  </Transition>

  );
};

export default ModalBoost;
